import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LegacyStateService } from '@core/services/upgraded-providers/wrappers/state.service.ts';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class AuthorizationExporedInterceptor implements HttpInterceptor {
    constructor(private stateService: LegacyStateService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === HttpStatusCode.Unauthorized && error.headers.has('x-authorization-access-token-expired')) {
                        this.stateService.goToLogout();
                    }

                    return throwError(() => error);
                }));
    }
}